import React, { useState } from 'react';
import { Stack, Button, Modal, TextField, useMediaQuery, Box } from '@mui/material';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { viVN } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/vi';
import dayjs from 'dayjs';

const AddScheduleModal = ({ time, open, handleAdd, handleClose, note = '' }) => {
    const [_time, setTime] = useState(time);
    const [_note, setNote] = useState(note);
    const isMobile = useMediaQuery('(max-width:600px)');

    const onClose = () => {
        if (handleClose) {
            handleClose();
        }
    };

    const onAdd = () => {
        if (handleAdd && _time) {
            handleAdd({ time: dayjs(_time).format(), note: _note });
            setNote(undefined);
        }
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: isMobile ? '90%' : 400,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                }}
            >
                <Stack spacing={2}>
                    <h4 style={{ textAlign: 'center' }}>Thêm lịch hẹn với khách hàng</h4>
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        localeText={viVN.components.MuiLocalizationProvider.defaultProps.localeText}
                        adapterLocale="vi"
                    >
                        <DemoContainer components={['MobileDateTimePicker']}>
                            <DemoItem label="Thời gian hẹn">
                                <MobileDateTimePicker
                                    value={_time}
                                    onChange={(value) => setTime(value)}
                                    format="HH:mm DD/MM/YYYY"
                                    label="Thời gian hẹn"
                                />
                            </DemoItem>
                        </DemoContainer>
                    </LocalizationProvider>
                    <TextField
                        label="Ghi chú"
                        fullWidth
                        multiline
                        rows={3}
                        variant="standard"
                        placeholder="Ghi chú"
                        value={_note}
                        onChange={(e) => setNote(e.target.value)}
                    />
                    <Stack
                        flexDirection="row"
                        spacing={2}
                        alignItems="center"
                        justifyContent="center"
                        sx={{ mt: 3 }}
                    >
                        <Button onClick={handleClose} color="warning" fullWidth>
                            Huỷ
                        </Button>
                        <Button disabled={!_time} onClick={onAdd} color="success" fullWidth>
                            Thêm lịch đặt
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
};

export default AddScheduleModal;